<template>
  <v-md-editor v-model="newContent" :disabled-menus="[]" @upload-image="handleUploadImage" class="mavonEditor"> </v-md-editor>
</template>
<script>
import { uploadPath } from '@/config/index.js'
const OSS = require('ali-oss')
import { put } from '@/utils/ali-oss'
export default {
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  computed: {
    newContent: {
      get() {
        return this.content
      },
      set(val) {
        this.$emit('update:content', val)
      }
    }
  },
  data() {
    return {}
  },
  created() {
    console.log(this.props, this.newContent)
  },
  methods: {
    handleUploadImage(event, insertImage, files) {
      if (this.$store.state.sysInfo.upload_type && this.$store.state.sysInfo.upload_type === 1) {
        this.handleBeforeUploadOss(files, insertImage)
        return
      } else {
        const formDataFile = new FormData()
        formDataFile.append('output', 'json')
        formDataFile.append('file', files[0])
        // 将图片上传到服务器
        let xhr = new XMLHttpRequest()
        xhr.open('post', uploadPath, true)
        xhr.send(formDataFile)
        let res = {}
        xhr.onload = () => {
          res = JSON.parse(xhr.responseText)
          // 上传成功后将图片添加到文档中
          insertImage({
            url: res.path,
            desc: files[0].name
            // width: 'auto',
            // height: 'auto',
          })
        }
      }
    },
    // 上传oss
    handleBeforeUploadOss(e, insertImage) {
      let file = e[0]
      if (file) {
        this.handleUpload(file, insertImage)
      } else {
        document.getElementById('files').value = null
        this.$msg.error('文件上传失败')
      }
    },
    // 图片上传阿里云
    async handleUpload(file, insertImage) {
      const params = {
        uriCode: 'API_PUB002'
      }
      const res = await this.$fetch(params)
      this.clientList = res
      // 自定义上传阿里云方法
      this.client = new OSS({
        region: 'oss-cn-beijing',
        accessKeyId: this.clientList.accessKeyId,
        accessKeySecret: this.clientList.accessKeySecret,
        stsToken: this.clientList.securityToken,
        bucket: 'svinsight-acs'
      })
      // 获取文件的后缀名
      const objs = file.name
      const index = objs.lastIndexOf('.')
      const filetype = objs.substring(index, objs.length)
      const fileName = objs.substring(0, index)
      // var obj = getFileNameUUID() + fileName
      // var obj = option.file.name
      var obj = fileName + filetype

      // 调用 ali-oss 中的方法,flieName是存放的文件夹名称，可自己定义
      put(`actual_combat/${obj}`, file, this.client, insertImage).then(res => {
        insertImage({
          url: res.url,
          desc: file.name
          // width: 'auto',
          // height: 'auto',
        })
        if (res.url) {
          this.$msg.success('文件上传成功')
        } else {
          this.$msg.error('文件上传失败')
        }
        // 上传成功之后，转换真实的地址
      })
    }
  }
}
</script>

<style scoped>
.mavonEditor {
  width: 100%;
  height: 100%;
  min-height: 500px;
}
</style>
